export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                COMPANY_MANAGE: 'COMPANY_MANAGE'
            },
            LABELS: {
                COMPANY_MANAGE: $translate.instant('role.companyPrivilege.companyManage')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });

    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/role/companyPrivilege/index.js